import React from 'react';
import PropTypes from 'prop-types';
import { useToggle } from '@src/components/hooks/useToggle';
import { LeaveReviewModal } from './leave-review-modal';
import { Button } from '@src/components/ui/button/button';
import { cn } from '@src/utils/ui';

export const LeaveReviewButton = ({ className, ...props }) => {
    const [isOpenLeaveReview, toggleIsOpenLeaveReview] = useToggle(false);

    const handleClick = e => {
        e.preventDefault();
        e.stopPropagation();
        toggleIsOpenLeaveReview(e);
    };

    return (
        <>
            <Button onClick={handleClick} variant='contained' className={cn(['tw-text-nowrap', className])}>
                LEAVE A REVIEW
            </Button>
            <LeaveReviewModal open={isOpenLeaveReview} onClose={toggleIsOpenLeaveReview} {...props} />
        </>
    );
};

LeaveReviewButton.propTypes = {
    className: PropTypes.string
};
